var path = 'entity/entity-type-select.tpl.html';
var html = "\n<md-input-container>\n    <label ng-if=\"showLabel\">{{ 'entity.type' | translate }}</label>\n    <md-select ng-required=\"tbRequired\" ng-disabled=\"disabled\" name=\"entityType\" ng-model=\"entityType\" class=\"tb-entity-type-select\" aria-label=\"{{ 'entity.type' | translate }}\">\n        <md-option ng-repeat=\"type in entityTypes\" ng-value=\"type\">\n            {{typeName(type) | translate}}\n        </md-option>\n    </md-select>\n    <div ng-messages=\"theForm.entityType.$error\">\n        <div ng-message=\"required\" translate>entity.type-required</div>\n    </div>\n</md-input-container>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity/entity-type-select.tpl.html
// module id = 1474
// module chunks = 1